export default __webpack_public_path__ + "images/solyluna_small.jpg";